if ($('body.type-posts-listing').length) {
    getUsps("#content");
    $('#navigation-1 a span').text().trim() == 'Blog' && $('body').addClass('subBlogPage');


    window.location.pathname.includes('/strana-') && $('body').addClass('notFirstPage') || $('body').removeClass('notFirstPage');
    if ($('.sectionDescription .top').length && !$('.breadcrumbs-wrapper .top').length) {
        $('.breadcrumbs-wrapper').append($('.sectionDescription .top').clone());
    }
    else if ($('.breadcrumbs-wrapper .top').length) {

    }
    else {
        var cached = sessionStorage.blogDescription;
        if (cached) {
            $('.breadcrumbs-wrapper').append(cached);

        }
        else {
            $.ajax({
                type: "GET",
                dataType: "html",
                timeout: 10000,
                cache: true,
                url: "/blog/",
                success: function (e) {
                    var doc = shoptet.common.createDocumentFromString(e);
                    var descriptionHtml = $(doc).find(".sectionDescription .top").prop('outerHTML');

                    if (descriptionHtml) {
                        sessionStorage.blogDescription = descriptionHtml;
                        $('.breadcrumbs-wrapper').append(descriptionHtml);
                    }
                }
            });
        }

    }


    $('body:not(.subBlogPage)').length && $('.breadcrumbs-wrapper .top>.text').append($('.subcategories').clone());
    $('.breadcrumbs-wrapper .top>.text').prepend($('h1').clone());

    $('h1').after('<div class="autor"></div>');



    document.addEventListener('ShoptetDOMPageContentLoaded', function () {
        window.location.pathname.includes('/strana-') && $('body').addClass('notFirstPage') || $('body').removeClass('notFirstPage');
    });


}
if ($('body.type-post').length) {
    getUsps('.content-wrapper');
    $('.breadcrumbs-wrapper').append($('.text .top').clone());
    $('.breadcrumbs-wrapper .top').prepend($('h1').clone());



    $('.blogPostInfo').html('');
    $('.blogPostInfo').append(`<span class="category">${$('#navigation-1>a>span').text()}</span>`);

    let postUrl = window.location.pathname;
    const relatedArticlesUrl = $('#navigation-1 > a[href]').attr('href');
    if (!postUrl.endsWith('/')) {
        postUrl += '/';
    }

    $.ajax({
        url: 'https://www.akce-incomputer.cz/api-get-postsTest.php',
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify({ urls: [postUrl] }),
        success: function (response) {
            const post = response && response.data && response.data[0];
            if (!post) return;

            if (post.author_name) {
                const authorImage = post.author_image
                    ? `<img src="${post.author_image}" alt="${post.author_name}">`
                    : '';

                $('.blogPostInfo').prepend(`
                    <span class="blogAuthor">
                        ${authorImage}
                        <span>${post.author_name}</span>
                    </span>
                `);
            }

            if (post.reading_minutes) {
                $('.blogPostInfo .category').before(`
                    <div class="blogMeta">
                        <span class="blogReading">${post.reading_minutes} ${translation('minCteni')}</span>
                    </div>
                `);
            }
        }
    });

    const renderRelatedArticles = function (content) {
        const $articles = $('<div>').html(content).find('.news-item').filter(function () {
                let articleUrl = $(this).find('.title').attr('href') || '';
                if (!articleUrl.endsWith('/')) {
                    articleUrl += '/';
                }

                return articleUrl !== postUrl;
            }).slice(0, 3).clone();

        if (!$articles.length) return;

        $articles.find('.blogMeta').remove();
        $articles.each(function () {
            const $article = $(this);
            const link = $article.find('.title').attr('href');

            $article.find('.text .description').after(`
                <div class="readBottom"><p class="readMore">
                    <a href="${link}" class="btn btn-secondary">Celý článek</a>
                </p></div>
            `);
        });

        const $relatedArticles = $(
            `<section class="type-posts-listing relatedBlogArticles">
                <h2>${translation('souvisejiciClanky')}</h2>
                <div id="newsWrapper" class="news-wrapper"></div>
            </section>`
        );

        $relatedArticles.find('#newsWrapper').append($articles);
        $('.content-wrapper-in').append($relatedArticles);
        loadReadingTimes($relatedArticles.find('#newsWrapper'));
    };

    const relatedArticlesStorageKey = `relatedBlogArticles:${relatedArticlesUrl}`;
    const cachedRelatedArticles = relatedArticlesUrl && localStorage.getItem(relatedArticlesStorageKey);
    if (cachedRelatedArticles) {
        renderRelatedArticles(cachedRelatedArticles);
    }
    else if (relatedArticlesUrl) {
        $.ajax({
            type: 'GET',
            dataType: 'html',
            timeout: 10000,
            cache: true,
            url: relatedArticlesUrl,
            success: function (html) {
                const doc = shoptet.common.createDocumentFromString(html);
                const content = $(doc).find('#newsWrapper').html();
                if (!content) return;

                localStorage.setItem(relatedArticlesStorageKey, content);
                renderRelatedArticles(content);
            }
        });
    }
}

if ($("#newsWrapper").length) {


    $('#newsWrapper .news-item').each(function () {
        const $item = $(this);
        if (!$item.find('.readMore').length) {
            const link = $item.find('.title').attr('href');
            $item.find('.text .description')
                .after(

                    `<div class="readBottom"><p class="readMore">
              <a href="${link}" class="btn btn-secondary">Celý článek</a>
            </p></div>`
                );
        }


    })


    loadReadingTimes($('#newsWrapper'));
}